import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dependentFilter'
})
export class DependentFilterPipe implements PipeTransform {

 transform(
    list: any[],
    selectedMpnId: string | null,
    selectedMfrId: string | null,
    type: 'mpn' | 'mfr',
    mpnList: any[]
  ): any[] {

    // Nothing selected → return full list
    if (!selectedMpnId && !selectedMfrId) {
      return list;
    }

    // Filtering MFR based on selected MPN
    if (type === 'mfr' && selectedMpnId) {
      const selectedMpn = mpnList?.find(m => m?.id === selectedMpnId);
      if (!selectedMpn) return list;

      return list.filter(mfr => mfr?.id === selectedMpn?.extra1 || mfr?.id === selectedMfrId);
    }

    // Filtering MPN based on selected MFR
    if (type === 'mpn' && selectedMfrId) {
      return list?.filter(mpn => mpn?.extra1 === selectedMfrId);
    }

    return list;
  }
}
